/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Content_PlaceholderInputs */

const en_settings_tickets_content_placeholder = /** @type {(inputs: Settings_Tickets_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your issue in detail...`)
};

/**
* | output |
* | --- |
* | "Describe your issue in detail..." |
*
* @param {Settings_Tickets_Content_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_content_placeholder = /** @type {((inputs?: Settings_Tickets_Content_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Content_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_content_placeholder(inputs)
});
export { settings_tickets_content_placeholder as "settings.tickets.content_placeholder" }